import { render, staticRenderFns } from "./ActivityPk.vue?vue&type=template&id=9156d548&scoped=true"
import script from "./ActivityPk.vue?vue&type=script&lang=js"
export * from "./ActivityPk.vue?vue&type=script&lang=js"
import style0 from "./ActivityPk.vue?vue&type=style&index=0&id=9156d548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9156d548",
  null
  
)

export default component.exports